import { ref, watch } from 'vue';

const THEME_KEY = 'admin-theme';
const DEFAULT_THEME = 'light';

const currentTheme = ref(DEFAULT_THEME);

export function useTheme() {
  const loadTheme = () => {
    const savedTheme = localStorage.getItem(THEME_KEY);
    currentTheme.value = savedTheme || DEFAULT_THEME;
    applyTheme(currentTheme.value);
  };

  const applyTheme = (theme) => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  const toggleTheme = () => {
    currentTheme.value = currentTheme.value === 'light' ? 'dark' : 'light';
    localStorage.setItem(THEME_KEY, currentTheme.value);
    applyTheme(currentTheme.value);
  };

  const setTheme = (theme) => {
    if (theme !== 'light' && theme !== 'dark') {
      console.warn(`Invalid theme: ${theme}. Using default: ${DEFAULT_THEME}`);
      theme = DEFAULT_THEME;
    }
    currentTheme.value = theme;
    localStorage.setItem(THEME_KEY, theme);
    applyTheme(theme);
  };

  watch(currentTheme, (newTheme) => {
    applyTheme(newTheme);
  });

  return {
    currentTheme,
    loadTheme,
    toggleTheme,
    setTheme,
    isDark: () => currentTheme.value === 'dark'
  };
}

